// extracted by mini-css-extract-plugin
export default {"tile":"FinanceTypeItem_tile__ugI3g","financeTile":"FinanceTypeItem_financeTile__OdlzV","financeLabel":"FinanceTypeItem_financeLabel__+mdhu"};